import axios from "axios.js";
import Actions from "./CRUD.action";

export const SET_APPART_HISTORY = "[ASSOCIATIONS APP] SET_APPART_HISTORY";

export function getAppartementByClientID(idClient, config = {}) {
  const request = axios.get(`/Appartement/client/${idClient}`, config);
  return (dispatch) =>
    request.then((response) => {
      const payload = response && response.data ? response.data.appartement || response.data : response;
      dispatch(payload);
    });
}

export function addOwner(idAppart, idOwner, config = {}) {
  const request = axios.put(
    `/Appartement/${idAppart}/owner/add/${idOwner}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) => {
      const d = response && response.data ? response.data : {};
      dispatch({
        type: Actions.SET_CLIENT,
        payload: d.proprietaire || d.client || null,
      });
      dispatch({
        type: Actions.SET_APPARTEMENT,
        payload: d.appartement || d.appart || null,
      });
    });
}

export function removeOwner(idAppart, idOwner, config = {}) {
  const request = axios.delete(
    `/Appartement/${idAppart}/owner/remove/${idOwner}`,
    config
  );
  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: Actions.SET_CLIENT,
        payload: response.data.proprietaire,
      });
      dispatch({
        type: Actions.SET_APPARTEMENT,
        payload: response.data.appartement,
      });
    });
}

export function addTenant(idAppart, idTenant, dossier, config = {}) {
  const request = axios.put(
    `/Appartement/${idAppart}/tenant/add/${idTenant}`,
    dossier,
    config
  );
  return (dispatch) =>
    axios
      .put(
        `/Appartement/${idAppart}`,
        {
          loyerHC: dossier.loyerHC,
          charge: dossier.loyerCharge,
        },
        config
      )
      .then((_) => {
        return request.then((response) => {
          const d = response && response.data ? response.data : {};
          dispatch({
            type: Actions.SET_LOCATAIRE,
            payload: d.locataire || null,
          });
          dispatch({
            type: Actions.SET_APPARTEMENT,
            payload: d.appartement || d.appart || null,
          });
          dispatch({ type: SET_APPART_HISTORY, payload: d.history || null });
          return response.data;
        });
      });
}

export function removeTenant(idAppart, idTenant, config = {}) {
  const request = axios.delete(
    `/Appartement/${idAppart}/tenant/remove/${idTenant}`,
    config
  );
  return (dispatch) =>
    request.then((response) => {
      const d = response && response.data ? response.data : {};
      dispatch({
        type: Actions.SET_LOCATAIRE,
        payload: d.locataire || null,
      });
      dispatch({
        type: Actions.SET_APPARTEMENT,
        payload: d.appartement || d.appart || null,
      });
      dispatch({ type: SET_APPART_HISTORY, payload: d.history || null });
    });
}

export function addMissionCustomer(idMission, idClient, config = {}) {
  const request = axios.put(
    `/Mission/${idMission}/client/add/${idClient}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: Actions.SET_MISSION, payload: response.data.mission });
      dispatch({ type: Actions.SET_CLIENT, payload: response.data.client });
    });
}

export function removeMissionCustomer(idMission, idClient, config = {}) {
  const request = axios.delete(
    `/Mission/${idMission}/client/remove/${idClient}`,
    config
  );
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: Actions.SET_MISSION, payload: response.data.mission });
      dispatch({ type: Actions.SET_CLIENT, payload: response.data.client });
    });
}

export function addMissionAccompte(idMission, idAccompte, config = {}) {
  const request = axios.put(
    `/Mission/${idMission}/accompte/add/${idAccompte}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_MISSION, payload: response.data })
    );
}

export function removeMissionAccompte(idMission, idAccompte, config = {}) {
  const request = axios.delete(
    `/Mission/${idMission}/accompte/remove/${idAccompte}`,
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_MISSION, payload: response.data })
    );
}

export function addMissionAppartement(idMission, idAppart, config = {}) {
  const request = axios.put(
    `/Mission/${idMission}/appartement/add/${idAppart}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_MISSION, payload: response.data })
    );
}

export function removeMissionAppartement(idMission, idAppart, config = {}) {
  const request = axios.put(
    `/Mission/${idMission}/appartement/remove/${idAppart}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_MISSION, payload: response.data })
    );
}

export function setAppartementEquipement(
  idAppart,
  idEquipement,
  add,
  config = {}
) {
  const request = axios.put(
    `/Appartement/${idAppart}/equipement/${
      add ? "add" : "remove"
    }/${idEquipement}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_APPARTEMENT, payload: response.data })
    );
}

export function removeAppartementImage(idAppart, idMission, config = {}) {
  const request = axios.put(
    `/Appartement/${idAppart}/image/remove/${idMission}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_APPARTEMENT, payload: response.data })
    );
}
export function addAppartementImage(idAppart, idMission, config = {}) {
  const request = axios.put(
    `/Appartement/${idAppart}/image/add/${idMission}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_APPARTEMENT, payload: response.data })
    );
}

export function addCautionDossier(idDossier, idCaution, config = {}) {
  const request = axios.put(
    `/Dossier/${idDossier}/caution/add/${idCaution}`,
    {},
    config
  );
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_DOSSIER, payload: response.data.dossier })
    );
}

export function setEtatInDossier(idDossier, form, config = {}) {
  const request = axios.put(`Dossier/${idDossier}/etatIn/set`, form, config);
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_DOSSIER, payload: response.data.dossier })
    );
}

export function setEtatOutDossier(idDossier, form, config = {}) {
  const request = axios.put(`Dossier/${idDossier}/etatOut/set`, form, config);
  return (dispatch) =>
    request.then((response) =>
      dispatch({ type: Actions.SET_DOSSIER, payload: response.data.dossier })
    );
}

const jsonToFormData = (obj) => {
  var form_data = new FormData();

  for (var key in obj) {
    form_data.append(key, obj[key]);
  }
  return form_data;
};

export function addFichierClient(idClient, form, config = {}) {
  return (dispatch) =>
    axios
      .post(`Fichier`, jsonToFormData(form), config)
      .then((file) =>
        axios
          .put(`Client/${idClient}/fichier/add/${file.data.id}`, {}, config)
          .then((response) =>
            dispatch({
              type: Actions.SET_CLIENT,
              payload: response.data.client,
            })
          )
      );
}

export function addFichierLocataire(idLocataire, form, config = {}) {
  return (dispatch) =>
    axios
      .post(`Fichier`, jsonToFormData(form), config)
      .then((file) =>
        axios
          .put(
            `Locataire/${idLocataire}/fichier/add/${file.data.id}`,
            {},
            config
          )
          .then((response) =>
            dispatch({
              type: Actions.SET_LOCATAIRE,
              payload: response.data.locataire,
            })
          )
      );
}
